﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";
import * as sessionModel from "~base/Services/API/Session/Model";

//-------------------------------------------------------------------------------------
// Http Contract
//-------------------------------------------------------------------------------------

const uri = (sessionId: number): string => {
    return `api/Guide/v1/Sessions/${sessionId}/Resume`;
};
const method = "POST";

// Shown when a refusal carries a fault code the tenant has authored no text for. A tenant that wants to
// state the reason adds a text for its own code instead of changing this one.
export const sessionNotResumableTextCode =
    "VisiFinance.Consilio.Application.Base.SessionNotPossibleToResume";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

interface ResumeSessionsProps extends api.ApiHookBaseProps<
    unknown,
    sessionModel.ResumeSessionResponse,
    unknown
> {
    sessionId?: number;
}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function useResumeSession(
    props: ResumeSessionsProps
): [boolean, (sessionId?: number) => Promise<unknown>] {
    const apiParams: api.ApiHookProps<
        unknown,
        sessionModel.ResumeSessionResponse,
        unknown
    > = {
        ...props,
        uri: uri(props.sessionId),
        method: method,
    };

    const [loading, invoker] = api.useApi<
        unknown,
        sessionModel.ResumeSessionResponse,
        unknown
    >(apiParams);
    return [
        loading,
        (sessionId?: number) =>
            invoker(sessionId != 0 ? uri(sessionId) : apiParams.uri, undefined),
    ];
}
